module.exports = __webpack_public_path__ + "static/media/calendar-purple.753c0e96.svg";